function isEmpresaSimplesNacional(enterprise) {
    return enterprise && (enterprise.crt === "1" || enterprise.crt === 1);
}

function getCsosnFromItem(item) {
    return item.csosnProduct || item.csosn || (item.csosnProduct?.code) || null;
}

function csosnGeraIcmsTotal(csosn) {
    const csosnSemIcms = ['102', '103', '300', '400'];
    return !csosnSemIcms.includes(csosn);
}

function csosnTemBaseCalculo(csosn) {
    return csosn === '101';
}

/**
 * @param {string} csosn - Código CSOSN
 * @returns {boolean}
 */
function csosnGeraCreditoPresumido(csosn) {
    return csosn === '101';
}

/**
 * @param {Array} itensVenda - Array de itens da venda
 * @param {Object} enterprise - Dados da empresa
 * @returns {string} - Valor formatado com 2 casas decimais
 */
function calculateIcmsTotal(itensVenda, enterprise) {
    if (!isEmpresaSimplesNacional(enterprise)) {
        return calcularIcmsNormal(itensVenda);
    }
    const itemsInfo = itensVenda.map(item => {
        const csosn = getCsosnFromItem(item);
        return {
            csosn: csosn,
            product: item.product?.name,
            value_icms: item.value_icms_product,
            gera_icms_total: csosnGeraIcmsTotal(csosn)
        };
    });
    
    const todosSemIcmsTotal = itensVenda.every(item => {
        const csosn = getCsosnFromItem(item);
        return !csosnGeraIcmsTotal(csosn);
    });
    
    if (todosSemIcmsTotal) {
        console.log('Zerando ICMS total para Simples Nacional');
        return "0.00";
    }
    
    return calcularIcmsNormal(itensVenda);
}

function calculateBaseIcmsTotal(itensVenda, enterprise) {
    console.log('=== CALCULO BASE ICMS SIMPLES ===');
    
    if (!isEmpresaSimplesNacional(enterprise)) {
        console.log('Empresa não é Simples Nacional, calculando base ICMS normal');
        return calcularBaseIcmsNormal(itensVenda);
    }

    let totalBaseIcms = 0;
    
    itensVenda.forEach(item => {
        const csosn = getCsosnFromItem(item);
        
        if (csosnTemBaseCalculo(csosn)) {
            totalBaseIcms += parseFloat(item.value_base_icms_product || 0);
        } else {
        }
    });
    
    return totalBaseIcms.toFixed(2);
}

function calculateCreditoIcmsSimples(itensVenda, enterprise) {
    if (!isEmpresaSimplesNacional(enterprise)) {
        return "0.00";
    }

    const creditValue = itensVenda
        .filter(item => {
            const csosn = getCsosnFromItem(item);
            return csosnGeraCreditoPresumido(csosn);
        })
        .map(item => parseFloat(item.value_icms_product || 0))
        .reduce((acc, curr) => acc + curr, 0);
    
    return creditValue.toFixed(2);
}

function calcularIcmsNormal(itensVenda) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    let result = itensVenda.map((e) => parseFloat(e.value_icms_product || 0));
    return result.reduce(reducer, 0).toFixed(2);
}

function calcularBaseIcmsNormal(itensVenda) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    let result = itensVenda.map((e) => parseFloat(e.value_base_icms_product || 0));
    return result.reduce(reducer, 0).toFixed(2);
}

module.exports = {
    calculateIcmsTotal,
    calculateBaseIcmsTotal,
    calculateCreditoIcmsSimples,
    isEmpresaSimplesNacional,
    getCsosnFromItem
};